import { useNavigate } from 'react-router-dom';
import InvestmentEntityDocuments from 'routes/Invest/InvestmentEntity/Documents';

import SidebarLayout, {
  SidebarLayoutContent,
  SidebarLayoutNavigation,
} from 'layouts/SidebarLayout';

const DocumentsAndVaultAccounts = () => {
  const navigate = useNavigate();

  return (
    <SidebarLayout>
      <SidebarLayoutNavigation
        onBackButtonClick={() => navigate(-1)}
        title="Documents"
        subTitle="View and manage your documents"
      />
      <SidebarLayoutContent>
        <InvestmentEntityDocuments />
      </SidebarLayoutContent>
    </SidebarLayout>
  );
};

export default DocumentsAndVaultAccounts;
